import {
  CostCenterExpensesSummary,
  CostCenterTransactions,
  CostCenterAccount,
  CostCentersHeader,
} from '@pages/cost-centers/containers';
import { Typography, Button, Badge } from '@ui/components';
import { useOutletContext, Link } from 'react-router-dom';
import { ArrowLeft } from '@ui/components/icons';
import { useTranslation } from 'react-i18next';

export const CostCenter = () => {
  const { t } = useTranslation();
  const { costCenter, canNavigateToList } = useOutletContext<{
    costCenter: { defaultCostCenter: boolean; name: string };
    canNavigateToList: boolean;
  }>();
  const { name, defaultCostCenter } = costCenter;

  return (
    <div className="flex flex-col min-h-full">
      <CostCentersHeader>
        <div className="flex items-center gap-2">
          {canNavigateToList && (
            <Link to="..">
              <Button variant="ghost" icon>
                <ArrowLeft />
              </Button>
            </Link>
          )}
          <Typography className="flex items-center gap-2" variant="h300" element="h1">
            {name}
            {defaultCostCenter && (
              <Badge className="h-4.5" variant="blue" size="small">
                {t('COST_CENTER.DEFAULT_COST_CENTER_BADGE')}
              </Badge>
            )}
          </Typography>
        </div>
      </CostCentersHeader>
      <div className="grid flex-1 min-h-auto sm:grid-cols-1 lg:grid-cols-12 auto-rows-[40px] gap-6 pb-8">
        <CostCenterAccount className="lg:col-span-6 row-span-5" />
        <CostCenterExpensesSummary className="lg:col-span-6 row-span-5" />
        <CostCenterTransactions />
      </div>
    </div>
  );
};
